import { render, staticRenderFns } from "./modalEditMiniGameStreak.vue?vue&type=template&id=fb25f750&"
import script from "./modalEditMiniGameStreak.vue?vue&type=script&lang=js&"
export * from "./modalEditMiniGameStreak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports